import themes from './themes/themes.js';

export default {
  // ambientes prod (NÃO MEXER!!!!!)
  'https://afiliado.betsul.bet.br': themes.betsul,
  'https://afiliado.lotese.com.br': themes.lotese,

  // ambientes dev
  'http://localhost:8080': themes.betsul,
  'https://afiliado-demolote.betplay.site': themes.lotese,
  'https://sysa-dev.sportingplay.info': themes.betsul
};
